export default {"theme":{"dark":false,"themes":{"light":{"primary":"#16215C","accent":"#F8A658","secondary":"#FAC999","info":"#ACBAE4","warning":"#E7755F","error":"#FF392B","success":"#49BEAA"}}}}
